// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-grid {\n  border: 1px solid #eceef5;\n}\n.form-grid .el-descriptions-item__content {\n  max-width: 200px;\n  min-width: 100px;\n  word-break: break-all;\n}", ""]);
// Exports
module.exports = exports;
